enum Colors {
  primary = '#88BE55',
  white = '#FFFFFF',
  light = '#f4f5f8',
  warning = '#ffc409',
  danger = '#eb445a',
}

export { Colors };